import confetti from 'canvas-confetti';
import { useEffect } from 'react';

import config from '../config/masterclass-rating-config.json';

export const useMasterclassRatingAnimation = (isSubmitted: boolean) => {
  useEffect(() => {
    if (!isSubmitted || !config.animations.confetti.enabled) return;

    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReducedMotion) return;

    const { particleCount, spread, colors } = config.animations.confetti;

    const fireStars = () => {
      void confetti({
        particleCount,
        spread,
        origin: { y: 0.6 },
        colors,
        shapes: ['star'],
        scalar: 1.2,
        gravity: 0.8,
        ticks: 200,
      });
    };

    // Burst initial
    fireStars();

    // Second burst après 300ms
    const timeout = setTimeout(fireStars, 300);

    return () => clearTimeout(timeout);
  }, [isSubmitted]);
};
